import Axios from "../../configs/axios.config";

export const configWorkspace = (data, id) =>
  Axios.put(`/workspaces/${id}`, data).then((response) => response.data.data);



export const getWorkspaceList = (data) => Axios.get('/workspaces', { params: data }).then(response => response.data.data);
export const deleteWorkspace = (id) => Axios.delete(`/workspaces/${id}`);
export const getWorkspaceDetail = (params) => Axios.get(`/workspace/detail`, {params}).then(response => response.data);
export const updateWorkspace = (data, id) => Axios.put(`/workspace/detail`, data).then(response => response.data.data);
export const createWorkspace = (data) => Axios.post(`/workspaces`, data).then(response => response.data.data);

export const requestPackage = (data) => Axios.post(`/workspaces/package-request`, data).then(response => response.data.data);
export const exportUsers = (params) => Axios.get(`/common/export-users`, {params}).then(response => response.data);



export const getLeaveApprovalList = () => Axios.get(`/leave-approval`).then(response => response.data);
// export const updateLeaveApproval = (data) => Axios.put(`/leave-approval`, data).then(response => response.data);
